import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#01ab4f", // Your provided color
      light: "#33c472", // 20% lighter
      dark: "#017736", // 30% darker
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#ab0159", // Complementary color
      light: "#d1337c", // 20% lighter
      dark: "#77013e", // 30% darker
      contrastText: "#ffffff",
    },
    success: {
      main: "#01ab4f", // Same as primary for consistency
      light: "#33c472",
      dark: "#017736",
    },
    error: {
      main: "#d32f2f", // Standard Material UI red
      light: "#ef5350",
      dark: "#c62828",
    },
    warning: {
      main: "#ed6c02", // Standard Material UI orange
      light: "#ff9800",
      dark: "#e65100",
    },
    info: {
      main: "#0288d1", // Standard Material UI blue
      light: "#03a9f4",
      dark: "#01579b",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#eeeeee",
      300: "#e0e0e0",
      400: "#bdbdbd",
      500: "#9e9e9e",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#212121",
    },
    background: {
      default: "#ffffff",
      paper: "#f8f9fa",
    },
    text: {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "rgba(0, 0, 0, 0.6)",
      disabled: "rgba(0, 0, 0, 0.38)",
    },
  },
  // Custom color tokens for your design system
  tokens: {
    surfaceVariant: "#e7f5ed", // Light green background
    onSurfaceVariant: "#014922", // Darker green for text on light backgrounds
    outline: "#70796f", // Border color
    outlineVariant: "#c1c9bf", // Lighter border color
  },
});

export default theme;
